// src/utils/responseParser.js

/**
 * Extracts HTML, CSS, and JS code blocks from the AI’s full text.
 * Returns { htmlCode, cssCode, jsCode }.
 */
export function extractCodeBlocks(fullText) {
  // only match fences with a newline after the language tag
  const RE = /```(\w+)?[^\S\r\n]*\r?\n([\s\S]*?)```/g;
  const blocks = [...fullText.matchAll(RE)];

  let html = '', css = '', js = '';
  for (const [, lang = '', code] of blocks) {
    const l = lang.toLowerCase();
    let trimmed = code.trim();

    if (l.includes('html')) {
      // drop your placeholder comment
      trimmed = trimmed.replace(/<!--\s*HTML here\s*-->/gi, '').trim();
      if (trimmed) html += trimmed + '\n';
    }
    else if (l.includes('css')) {
      // drop your placeholder comment
      trimmed = trimmed.replace(/\/\*\s*full CSS here\s*\*\//gi, '').trim();
      if (trimmed) css += trimmed + '\n';
    }
    else if (l.includes('js')) {
      // drop your placeholder comment
      trimmed = trimmed.replace(/^\/\/\s*full JavaScript here\s*$/gim, '').trim();
      if (trimmed) js += trimmed + '\n';
    }
  }

  return {
    htmlCode: html.trim(),
    cssCode:  css.trim(),
    jsCode:   js.trim()
  };
}


/**
 * Strips out all ``` ``` code fences, leaving only the plain explanation.
 */
export function extractExplanation(fullText) {
  return fullText.replace(/```[\s\S]*?```/g, '').trim();
}
